import React, { useMemo } from 'react';

import moment from 'moment';

import AppBar from 'components/AppBar';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { TravelContainer, TravelInfo, DateInfo, DaysInfo, Clock } from './styles';

interface InfoProps {
  pickUpPoint?: string;
  pickUpDate?: Date;
  dropOffDate?: Date;
}

export interface Props {
  info: InfoProps;
  loading: boolean;
  goBack: () => void;
  onEdit: () => void;
}

const AutoHeader = ({ info, loading, goBack, onEdit }: Props) => {
  const { t } = useStoreTranslation();
  const qtyDays = useMemo(() => {
    const days = moment(info.dropOffDate).diff(moment(info.pickUpDate), 'days');
    return days > 1 ? `${days} ${t('autosCard.category.priceDays')}` : `1 ${t('autosCard.category.priceDay')}`;
  }, [info, t]);

  return (
    <AppBar goBack={goBack} loading={loading} rightLabel={t('autosSearch.edit')} rightAction={onEdit}>
      <TravelContainer>
        <TravelInfo>{info.pickUpPoint}</TravelInfo>
      </TravelContainer>
      <DateInfo>
        {moment(info.pickUpDate).format('ddd DD, MMM')}
        {`${info.dropOffDate ? ` - ${moment(info.dropOffDate).format('ddd DD, MMM')}` : ''}`}
        <DaysInfo>
          <Clock src="/corporate/images/autos/icon-clock.svg" />
          {qtyDays}
        </DaysInfo>
      </DateInfo>
    </AppBar>
  );
};

export default AutoHeader;
